import NumberFormat from "react-number-format";
import React from "react";
import _ from "lodash";
import styled from "styled-components";

const B14 = styled('span')`
  font-size: 14px;
`;

const S10 = styled('span')`
  font-size: 10px;
  color: #424242;
`;

const StyledTable = styled('table')`
  && {
    width: 100%;
    border-spacing: 0 16px;
  }
`;

function thursdayDistance(datum) {
  const d = new Date(datum.date) - new Date(datum.auctionThursday);
  return d / 1000 / 3600 / 24;
}

const WeekFeesTable = ({rows, data, setFilters}) => {
  const rowsWithDays = rows.map(row => {
    const typeData = data.filter(datum => datum.type === row.type);
    const before_thursday = typeData.filter(datum => thursdayDistance(datum) < 0);
    const thursday = typeData.filter(datum => thursdayDistance(datum) >= 0 && thursdayDistance(datum) < 1);
    const friday = typeData.filter(datum => thursdayDistance(datum) >= 1 && thursdayDistance(datum) < 2);
    const after_friday = typeData.filter(datum =>  thursdayDistance(datum) > 2);
    return {
      ...row,
      before_thursday: _.sumBy(before_thursday, 'fee'),
      thursday: _.sumBy(thursday, 'fee'),
      friday: _.sumBy(friday, 'fee'),
      after_friday: _.sumBy(after_friday, 'fee'),
      before_thursday_count: before_thursday.length,
      thursday_count: thursday.length,
      friday_count: friday.length,
      after_friday_count: after_friday.length,
    }
  })

  return (<>
    <StyledTable>
      <tbody style={{lineHeight: 1, fontSize: 12}}>
        <tr style={{color: '#616161'}}>
          <td> &nbsp; </td>
          <td style={{paddingLeft: 25}}>Bef. Thursday</td>
          <td>Thursday</td>
          <td>Friday</td>
          <td>After Friday</td>
          <td>Total</td>
        </tr>
        {rowsWithDays.map((row) => (
          <tr onClick={() => setFilters(row.type)} style={{cursor: 'pointer'}}>
            <td style={{color: '#616161'}}>
              {row.label}
            </td>
            <td style={{border: '1px solid #CECECE', borderRight: 'none', paddingLeft: 25}}>
              <B14>
                <NumberFormat value={row.before_thursday} displayType="text" thousandSeparator prefix="$" />
                {' '}
              </B14>
              <S10>{!!row.before_thursday_count && `(${row.before_thursday_count})`}</S10>
            </td>
            <td style={{borderTop: '1px solid #CECECE' ,borderBottom: '1px solid #CECECE'}}>
              <B14>
                <NumberFormat value={row.thursday} displayType="text" thousandSeparator prefix="$" />
                {' '}
              </B14>
              <S10>{!!row.thursday_count && `(${row.thursday_count})`}</S10>
            </td>
            <td style={{borderTop: '1px solid #CECECE', borderBottom: '1px solid #CECECE'}}>
              <B14>
                <NumberFormat value={row.friday} displayType="text" thousandSeparator prefix="$" />
                {' '}
              </B14>
              <S10>{!!row.friday_count && `(${row.friday_count})`}</S10>
            </td>
            <td style={{borderTop: '1px solid #CECECE', borderBottom: '1px solid #CECECE'}}>
              <B14>
                <NumberFormat value={row.after_friday} displayType="text" thousandSeparator prefix="$" />
                {' '}
              </B14>
              <S10>{!!row.after_friday_count && `(${row.after_friday_count})`}</S10>
            </td>
            <td style={{border: '1px solid #CECECE', borderLeft: 'none'}}>
              <B14>
                <NumberFormat value={row.before_thursday + row.thursday + row.friday + row.after_friday} displayType="text" thousandSeparator prefix="$" />
                {' '}
              </B14>
              <S10>{`(${row.before_thursday_count + row.thursday_count + row.friday_count + row.after_friday_count})`}</S10>
            </td>
          </tr>
        ))}
      </tbody>
    </StyledTable>
  </>);
}

export default WeekFeesTable
